// dashbaord
import Default from '../components/dashboard/default'
import Trip from '../components/dashboard/Trip_details'
import SignIn from "../auth/signin";
import Buyer from "../components/dashboard/Buyer_details";
import Driver from "../components/dashboard/driver_details";
import Vehicle from '../components/dashboard/vehicle_details';
import Inventory from '../components/dashboard/Inventory_details';
import Bill from '../components/dashboard/Invoice_details';
import Trip_Driver_details from '../components/dashboard/Trip_Driver_details';
import Trip_Vehicle_details from '../components/dashboard/Trip_vehicle_details';
import Invoice_vehicle_details from '../components/dashboard/Invoice_vehicle_details';
import Trip_Buyer_details from '../components/dashboard/Trip_Buyer_details';
import Account from "../components/dashboard/Account_details";
import Map from "../components/dashboard/Map_details";


// starter kits 
// import Starterkits from '../components/starter-kits'

export const routes = [
        { path:`${process.env.PUBLIC_URL}/`, Component:SignIn},
        { path:`${process.env.PUBLIC_URL}/Home`, Component:Default},
        { path:`${process.env.PUBLIC_URL}/Driver_Details`, Component:Driver},
        { path:`${process.env.PUBLIC_URL}/Trip_Details`, Component:Trip},
        { path:`${process.env.PUBLIC_URL}/Buyer_Details`, Component:Buyer},
        { path:`${process.env.PUBLIC_URL}/Inventory_Details`, Component:Inventory},
        { path:`${process.env.PUBLIC_URL}/Bill_Details`, Component:Bill},
        { path:`${process.env.PUBLIC_URL}/Vehicle_Details`, Component:Vehicle},
        { path:`${process.env.PUBLIC_URL}/Tripdriver`, Component:Trip_Driver_details},
        { path:`${process.env.PUBLIC_URL}/Tripvehicle`, Component:Trip_Vehicle_details},
        { path:`${process.env.PUBLIC_URL}/Invoicevehicle`, Component:Invoice_vehicle_details},
        { path:`${process.env.PUBLIC_URL}/Tripbuyer`, Component:Trip_Buyer_details},
        { path:`${process.env.PUBLIC_URL}/Account`, Component:Account},
        { path:`${process.env.PUBLIC_URL}/Map`, Component:Map},
     

        
]